<template lang="pug">
    div()
        v-dialog(v-model="loginDialog" width="460" style="z-index:100000" class="test")
            //- Signup
            v-card(v-if="getRegisterType === 'signup'" ref="loginDialogWindow" class="popup-modal-account-create")

                h4() {{ $t('Create_account') }}

                div(class="modal-form-item")
                    label() {{ $t('Your_eMail') }}
                    v-text-field(
                        @keydown.enter="addUser()"
                        v-model="email"
                        :type="'text'"
                        :placeholder="$t('email')"
                        outlined dense
                        height=40
                        :hide-details="true"
                        )

                div(class="modal-form-item")
                    label() {{ $t('Choose_your_password') }}
                    v-text-field(
                        @keydown.enter="addUser()"
                        v-model="password"
                        name="password"
                        :hint="$t('minimum_eight_characters')"
                        counter
                        outlined dense
                        :type="showPass ? 'text' : 'password'"
                        class="toggle"
                        height=40
                        :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="showPass = !showPass"
                        :dark="false"
                        :placeholder="$t('Password')"
                        id="inputRegisterPassword"
                    )

                div(class="modal-form-item-cols")
                    label()
                        input( type="checkbox" id="customControlInline" v-model="rememberMe")
                        span() {{ $t('Remember_me') }}
                    v-btn(@click.prevent="addUser()" class="btn-main") {{ $t('Create_account') }}

                div(class="modal-form-item gsb")
                    div(style="position:relative; overflow:hidden")
                        button(class="btn-wide")
                            img(src="/images/sso_google.png")
                            span() {{ $t('Continue_withGoogle') }}
                        div(id="signin_button")

                div(class="modal-form-item text-center")
                    span(class="mr-4") {{ $t('Have_account') }}
                    span(@mouseup="setRegisterType('login'), switchBetweenLoginSignup = true" class="" style="cursor:pointer;") {{ $t('Log_in') }}

            //- Login
            v-card(v-else-if="getRegisterType === 'login'" ref="loginDialogWindow" class="popup-modal-account-login")

                h4() {{ $t('Login_account') }}

                div(class="modal-form-item")
                    label() {{ $t('Your_eMail') }}
                    v-text-field(
                        @keydown.enter="login()"
                        v-model="email"
                        :type="'text'"
                        :placeholder="$t('email')"
                        outlined dense
                        height=40
                        :hide-details="true"
                    )

                div(class="modal-form-item")
                    label() {{ $t('Your_password') }}
                    v-text-field(
                        @keydown.enter="login()"
                        v-model="password"
                        name="password"
                        outlined dense
                        :type="showPass ? 'text' : 'password'"
                        class="-toggle"
                        height=40
                        :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="showPass = !showPass"
                        :dark="false"
                        :placeholder="$t('Password')"
                        :hide-details="true"
                    )

                div(class="modal-form-item-cols")
                    label()
                        input( type="checkbox" v-model="rememberMe")
                        span() {{ $t('Remember_me') }}
                    div(@mouseup="setRegisterType('forgotten')" class="" style="")
                                span(style="cursor:pointer;") {{ $t('Forgotten_password') }}?

                div(class="modal-form-item")
                    v-btn(@click.prevent="login()" class="btn-main btn-wide") {{ $t('Log_in') }}

                div(class="modal-form-item gsb")
                    div(style="position:relative; overflow:hidden")
                        button(class="btn-wide")
                            img(src="/images/sso_google.png")
                            span() {{ $t('Continue_withGoogle') }}
                        div(id="signin_button")

                div(class="modal-form-item text-center")
                    span(class="mr-4") {{ $t('No_account') }}
                    span(@mouseup="setRegisterType('signup'), switchBetweenLoginSignup = true" class="" style="cursor:pointer;") {{ $t('Register') }}

            //- Reset Password
            v-card(v-else-if="getRegisterType === 'forgotten'" ref="loginDialogWindow" class="popup-modal-account-reset")

                h4(class="text-left") {{ $t('Reset_Password') }}

                p() {{ $t('enter_user_account') }}

                div(class="modal-form-item")
                    label() {{ $t('email') }}
                    v-text-field(
                        v-model="email"
                        outlined dense
                        height=40
                        :placeholder="$t('email')"
                        :disabled="is_submitted"
                        required
                    )

                    v-text-field(
                        v-show="is_submitted"
                        v-model="confirmCodeEntered"
                        :placeholder="$t('confirm_code_via_email')"
                        :disabled="is_confirmed"
                        :label="$t('confirm_code')"
                        height=40
                        required
                        outlined
                    )

                    v-text-field(
                        v-show="is_confirmed"
                        v-model="password"
                        :placeholder="$t('Password')"
                        :type="showPass ? 'text' : 'password'"
                        :label="$t('Password')"
                        :hint="$t('minimum_eight_characters')"
                        height=40
                        counter
                        outlined
                    )

                    v-btn(
                        v-show="is_submitted == false && is_confirmed == false"
                        @click.prevent="getCode()"
                    ) {{ $t('email_secret_code') }}

                    v-btn(
                        v-show="is_submitted && is_confirmed == false"
                        @click.prevent="confirm()"
                    ) {{ $t('confirm_code') }}

                    v-btn(
                        v-show="is_confirmed"
                        @click.prevent="newPassword()"
                    ) Submit
</template>

<script>
import ApiService from './../Services/ApiService';
import Cookies from 'js-cookie';
import { mapGetters, mapMutations } from 'vuex';
import jwt_decode from "jwt-decode";

export default {
    name: 'LoginDialogWindow',
    data() {
        return {
            switchBetweenLoginSignup: false,
            loginDialog: false,
            showPass: false,
            email: '',
            password: '',
            rememberMe: false,
            is_submitted: false,
            is_confirmed: false,
            confirmCode: null,
            confirmCodeEntered: null
        };
    },
    computed: {
        ...mapGetters([
            'getRegisterWindows',
            'getRegisterType'
        ])
    },
    watch: {
        switchBetweenLoginSignup() {
            if(this.switchBetweenLoginSignup) {
                this.createGoogleLogin();

                setTimeout(() => {
                    this.switchBetweenLoginSignup = false;
                }, 300);
            }
        },
        loginDialog() {
            if(this.loginDialog) {
                this.createGoogleLogin();
            }
        },
        getRegisterWindows() {
            this.loginDialog = this.getRegisterWindows;

            // console.log(this.loginDialog);

            if(this.loginDialog) {
                setTimeout(() => {
                    window.addEventListener('click', this.close);
                }, 300);
            }
        }
    },
    methods: {
        ...mapMutations([
            'setRegisterWindows',
            'setRegisterType'
        ]),
        createGoogleLogin() {
            setTimeout(() => {
                // console.log(window.google);

                window.google.accounts.id.initialize({
                    client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
                    callback: this.handleCredentialResponse
                });

                window.google.accounts.id.renderButton(
                    document.getElementById("signin_button"),
                    {
                        theme: "icon",
                        size: "medium",
                        width: 350
                    }
                );
            }, 50);
        },
        handleCredentialResponse(response) {
            // console.log(response);

            const token = response.credential;
            const decoded = jwt_decode(token);

            // console.log(decoded.email);

            this.email = decoded.email;
            this.password = "asdfasdf";

            this.GoogleFacebooksignin();
        },
        async getCode() {
            if (this.email === '') {
                this.$store.commit('setMessage', { text: 'Required email', type: 'error' });

                return;
            }

            try {
                const userEmailObject = {
                    email: this.email
                };

                const response = await ApiService.forgotPassword(userEmailObject);

                if (response.flag !== undefined) {
                    throw new Error(response);
                }

                this.confirmCode = response;
                this.is_submitted = true;

                // console.log(this.confirmCode);
            } catch(error) {
                this.submitFailed(error);
            }
        },
        confirm() {
            if (this.confirmCode === this.confirmCodeEntered) {
                this.is_confirmed = true;
            } else {
                this.$store.commit('setMessage', { text: 'Wrong code', type: 'error' });
            }
        },
        async newPassword () {
            if (this.password.length < 8) {
                this.$store.commit('setMessage', { text: 'Password should be 8 letters at least', type: 'error' });
            } else {
                try {
                    await ApiService.newPassword({
                        email: this.email,
                        password: this.password
                    });

                    const response = await ApiService.userLogin({
                        email: this.email,
                        password: this.password,
                    });

                    if(this.rememberMe) {
                        Cookies.set('user', JSON.stringify(response.data));
                    }

                    localStorage.setItem('user', JSON.stringify(response.data));

                    if(this.getShortCode !== undefined) {
                        localStorage.setItem(`${this.getShortCode}`, true);
                    }

                    window.location.href = '/';
                } catch (error) {
                    this.loginFailed(error);
                }
            }
        },
        submitFailed(error) {
            this.$store.commit('setMessage', { text: error.message || 'Error Submit', type: 'error' });

            localStorage.removeItem('user');
            Cookies.remove('user');
        },
        async login()  {
            if (this.email === "" || this.password === "") {
                this.$store.commit('setMessage', { text: 'e-post och lösenord krävs', type: 'error' });
            } else {
                try {
                    // for(const competition of this.getCompetitions) {
                    //     localStorage.removeItem(`${competition.short_code}`);
                    // }

                    const response = await ApiService.userLogin({
                        email: this.email,
                        password: this.password
                    });

                    // console.log(response.data);

                    this.$store.commit('setMessage', { text: 'logged in', type: 'success' });

                    if(this.rememberMe) {
                        Cookies.set('user', JSON.stringify(response.data));
                    }

                    localStorage.setItem('user', JSON.stringify(response.data));

                    window.location.href = '/';

                    // if(this.getShortCode !== undefined) {
                    //     localStorage.setItem(`${this.getShortCode}`, true);
                    // }

                    // const urlParams = new URLSearchParams(window.location.search);

                    // if(urlParams.get('stockOverview') !== null) {
                    //     let fullUrlWithQueries = '';

                    //     if(urlParams.get('period') !== null) {
                    //         fullUrlWithQueries = `${urlParams.get('stockOverview')}&period=${urlParams.get('period')}`;
                    //     } else if (/tab/i.test(urlParams.get('stockOverview'))) {
                    //         fullUrlWithQueries = urlParams.get('stockOverview');
                    //     } else {
                    //         fullUrlWithQueries = `${urlParams.get('stockOverview')}&tab=2`;
                    //     }

                    //     window.location.href = fullUrlWithQueries;
                    // } else if(urlParams.get('unsubscribe_email_newsletter') !== null) {
                    //     window.location.href = "/rapportkollen/watchlist/?unsubscribe_email_newsletter=true";
                    // } else if(urlParams.get('show_premium') !== null) {
                    //     window.location.href = "/rapportkollen/watchlist/?show_premium=true";
                    // } else if(urlParams.get('verify_user') !== null) {
                    //     const user_id = urlParams.get('verify_user');

                    //     await ApiService.verifyAndLogin(user_id);

                    //     if(localStorage.getItem('user') !== null) {
                    //         let localUser = JSON.parse(localStorage.getItem('user'));

                    //         localUser.type = 'freemium';

                    //         localStorage.setItem('user', JSON.stringify(localUser));

                    //         if(this.getShortCode !== undefined) {
                    //             localStorage.setItem(`${this.getShortCode}`, true);
                    //         }
                    //     }

                    //     window.location.href = `/rapportkollen/watchlist/?verify_user=true`;
                    // } else {
                    //     window.location.href = "/rapportkollen";
                    // }
                } catch(error) {
                    this.loginFailed(error);
                }
            }
        },
        loginFailed(error) {
            this.$store.commit('setMessage', { text: error.message || ": inloggningen misslyckades", type: 'error' });

            localStorage.removeItem('user');
            Cookies.remove('user');
        },
        async addUser() {
            // console.log('Funka?');

            if (this.email === "" || this.password === "") {
                this.$store.commit('setMessage', { text: 'e-post och lösenord krävs', type: 'error' });
            } else if (this.password.length < 8) {
                this.$store.commit('setMessage', { text: 'Minst 8 tecken', type: 'error' });
            } else {
                try {
                    const response  = await ApiService.addUser({
                        email: this.email,
                        password: this.password,
                    });

                    response.data.password = 'secret';

                    this.$store.commit("setMessage", { text: "logged in", type: "success" });

                    if(this.rememberMe) {
                        Cookies.set('user', JSON.stringify(response.data));
                    }

                    localStorage.setItem('user', JSON.stringify(response.data));

                    // if(this.getShortCode !== undefined) {
                    //     localStorage.setItem(`${this.getShortCode}`, true);
                    // }

                    window.location.href = '/';
                } catch (error) {
                    this.loginFailed(error);
                }
            }
        },
        async GoogleFacebooksignin() {
            try {
                const response  = await ApiService.continue_GF({
                    email: this.email,
                    password: this.password,
                });

                this.$store.commit('setMessage', { text: 'logged in', type: 'success' });

                if(this.rememberMe) {
                    Cookies.set('user', JSON.stringify(response.data));
                }

                localStorage.setItem('user', JSON.stringify(response.data));

                if(this.getShortCode !== undefined) {
                    localStorage.setItem(`${this.getShortCode}`, true);
                }

                window.location.href = "/";
            } catch (error) {
                this.loginFailed(error);
            }
        },
        close(e) {
            try {
                if(!this.$refs.loginDialogWindow.$el.contains(e.target)) {
                    // console.log('click outside...');
                    this.setRegisterWindows(false);

                    window.removeEventListener('click', this.close);
                } else {
                    // console.log('click inside...');
                }
            } catch (error) {
                // console.log(error.message);
            }
        }
    }
}
</script>

<style scoped>

[class*="popup-modal-"] {
    border-radius: 8px;
    padding: 24px;
}

[class*="popup-modal-"] > h4 {
    font-size: 24px;
    margin-bottom: 24px;
    padding: 0;
    text-align: center;
    text-transform: capitalize;
    border: 0px solid;
}

[class*="popup-modal-"] > p {

}

[class*="popup-modal-"] [class*="-form-item"] {
    border: 0px solid red;
    margin-bottom: 16px;
    padding: 0;
}

[class*="-form-item-cols"] {
    align-items: center;
    display: flex;
    font-size: 14px;
    justify-content: space-between;

}

>>>[class*="-form-item"] fieldset {
    border: 0 !important;
}

>>>[class*="-form-item"] .v-input__slot {
    border: 1px solid rgba(20,75,77,1);
}

[class*="popup-modal-"] [class*="-form-item"] label {
    margin: 0 0 6px 0;
}

/*workaround here*/
[class*="-form-item"] .v-btn:not(.v-btn--round).v-size--default {
    height: auto !important;
}

[class*="-form-item"] .v-input.toggle {
    height: 64px;
}
/**/

[class*="-form-item"] [class*="btn-"] {
    border-radius: 6px;
    padding: 6px 16px;
}

[class*="-form-item"] .btn-main,
[class*="-form-item"] .v-btn {
    background-color: rgba(20,75,77,1);
    color: #fff;
    font-size: 13px;
    padding: 10px 20px;
    text-transform: capitalize;
}

[class*="-form-item"] .btn-wide,
.popup-modal-account-reset .v-btn {
    width: 100%;
}

[class*="-form-item"] input[type="checkbox"] {
    border-radius: 6px;
    height: 20px;
    margin-right: 6px;
    width: 20px;
}

label input[type="checkbox"],
label input[type="checkbox"] + span {
    display: inline-block;
    vertical-align: middle;
}


/* Google btn */
[class*="-form-item"].gsb button {
    border: 1px solid rgba(20,75,77,.8);
    cursor: pointer;
    padding: 10px 20px;
    width: 100%;
}

[class*="-form-item"].gsb:hover {
    filter: grayscale(1);
}

.gsb span {
    margin-left: 20px;
}

.gsb img {
    display: inline-block;
    height: 24px;
    width: 24px;
    vertical-align: middle;
}

>>>#signin_button {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    opacity: 0.0000000001;
}
/**/


</style>
